/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2025-2026 (c) Miriam Mack, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import styles from './RoleBadges.module.css';

const ROLE_LABELS: Record<string, string> = {
  SuperAdmin: 'Super Admin',
  Admin: 'Admin',
  CompanyMember: 'Member',
};

const RoleBadge = ({ role }: { role: string }) => (
  <span className={styles['role-badge']}>{ROLE_LABELS[role] ?? role}</span>
);

export default RoleBadge;
